module.exports = __webpack_public_path__ + "img/macedonia.5ed00dc.webp";